// extracted by mini-css-extract-plugin
export default {"wrap":"sJ-z","fullWidth":"tJ-z","hideOnDesktop":"uJ-z","content":"vJ-z","hasOpenedNav":"wJ-z","crumbsList":"xJ-z","dropdownsWrap":"yJ-z"};